import React, { useEffect } from "react";
import { Auth } from "aws-amplify";
import { useNavigate } from "react-router-dom";

interface LogoutPageProps {
  onSignedOut?: () => void;
}

const LogoutPage: React.FC<LogoutPageProps> = ({ onSignedOut }) => {
  const navigate = useNavigate();

  useEffect(() => {
    const signOut = async () => {
      onSignedOut?.();
      try {
        await Auth.signOut({ global: true });
      } catch {}

      try {
        const keys = Object.keys(window.localStorage);
        for (const key of keys) {
          if (key.includes("CognitoIdentityServiceProvider") || key.startsWith("amplify-")) {
            window.localStorage.removeItem(key);
          }
        }
      } catch {}

      try {
        navigate("/", { replace: true });
      } catch {
        window.location.assign("/");
      }
    };

    signOut();
  }, [navigate, onSignedOut]);

  return (
    <div className="flex h-screen items-center justify-center">
      <div>
        <h1 className="text-2xl font-bold mb-4">Signing you out...</h1>
        <p className="text-gray-600">Please wait while we log you out.</p>
      </div>
    </div>
  );
};

export default LogoutPage;
